import React, { useState, useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import BackImage from '../../../assets/images/backImage.png';
import {
  TrainsType,
  TransitsApi,
  TransitsCustomType
} from '../../../apis/Transits.api';
import { ClockApi, ClockType } from '../../../apis/Clock.api';
import { AnemometersApi, AnemometersType } from '../../../apis/Anemometers.api';
import { Anemometer } from '../../atoms/Anemometer';
import { InaccurateTrain } from '../../atoms/InaccurateTrain';
import { OverlapTrain } from '../../atoms/OverlapTrain';
import { Train } from '../../atoms/Train';
import { TrainDetail } from '../../atoms/TrainDetail';
import { AnomalyTrainTable } from '../../molecules/AnomalyTrainTable';
import { Clock } from '../../molecules/Clock';
import { LineImages } from './LineImages';
import { AnomalyTrain } from '../../atoms/AnomalyTrain';

export const LocationBody: React.FC = () => {
  const [transits, setTransits] = useState<TransitsCustomType>();
  const [clockData, setClock] = useState<ClockType>();
  const [anemometers, setAnemometers] = useState<AnemometersType>();
  const anemometerElRef = React.createRef<SVGTextElement>();
  const [anemoX, setAnemoX] = useState<number>(0);
  const [anemoY, setAnemoY] = useState<number>(0);
  const [detailDisp, setDetailDisp] = useState<TrainsType[]>();

  const GetApi = async () => {
    setTransits(await TransitsApi());
    setAnemometers(await AnemometersApi());
  };
  const GetClockApi = async () => {
    const data = await ClockApi();
    setClock({ now: new Date(data.now), weekday: data.weekday });
  };

  // API データ取得
  useEffect(() => {
    GetApi();
    GetClockApi();
    const clockInteval = setInterval(async () => await GetClockApi(), 500);
    const interval = setInterval(async () => await GetApi(), 5000);
    return () => {
      clearInterval(interval);
      clearInterval(clockInteval);
    };
  }, []);

  useEffect(() => {
    if (transits !== undefined && detailDisp !== undefined) {
      const array = transits.datas.filter(
        (train) => train.trains[0].train_no === detailDisp[0].train_no
      );
      if (array.length !== 0) {
        setDetailDisp(array[0].trains);
      } else {
        setDetailDisp(undefined);
      }
    }
  }, [transits, detailDisp]);

  return (
    <>
      <Box
        w='100%'
        h='100%'
        position='relative'
        bgColor='black'
        display='grid'
        gridTemplateColumns='3% 30% 3fr 3fr'
        gridTemplateRows='1.4fr 2fr 3fr'
      >
        <svg
          viewBox='0,-20,1920,1080'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }}
        >
          <image xlinkHref={BackImage} />
          <LineImages />

          {clockData !== undefined && (
            <Clock anemoX={anemoX} anemoY={anemoY} clockData={clockData} />
          )}
          <Anemometer
            anemometer={anemometers}
            elRef={anemometerElRef}
            setAnemoX={setAnemoX}
            setAnemoY={setAnemoY}
          />

          {transits?.datas.map((data, i) => {
            if (data.trains.length > 1) {
              return (
                <OverlapTrain
                  key={`${'spot_' + i}`}
                  trainsData={data}
                  setDetailDisp={setDetailDisp}
                />
              );
            } else if (data.trains[0].obc_error_flg) {
              return (
                <AnomalyTrain
                  key={`${'spot_' + i}`}
                  trainData={data.trains}
                  setDetailDisp={setDetailDisp}
                />
              );
            } else if (data.trains[0].data_status === 1) {
              return (
                <Train
                  key={`${'spot_' + i}`}
                  trainData={data.trains}
                  setDetailDisp={setDetailDisp}
                />
              );
            } else if (data.trains[0].data_status === 2) {
              return (
                <InaccurateTrain
                  key={`${'spot_' + i}`}
                  trainData={data.trains}
                  setDetailDisp={setDetailDisp}
                />
              );
            }
          })}
          {detailDisp !== undefined && (
            <TrainDetail
              detailDisp={detailDisp}
              setDetailDisp={setDetailDisp}
            />
          )}
        </svg>

        {transits?.obc_error.length !== undefined &&
          transits?.obc_error.length > 0 && (
            <AnomalyTrainTable obcErrorDatas={transits?.obc_error} />
          )}

        {/*stationTimeWindow !== undefined && (
          <StationTimeWindow
            isOpen={isOpen}
            onClose={onClose}
            stationTimeWindow={stationTimeWindow}
            setStationTimeWindow={setStationTimeWindow}
          />
        )*/}
      </Box>
    </>
  );
};
